const FilterIcon = [
    {
        img:"https://a0.muscache.com/pictures/aaa02c2d-9f0d-4c41-878a-68c12ec6c6bd.jpg",
        title:"Amazing views"
    },
    {
        img:"https://a0.muscache.com/pictures/6ad4bd95-f086-437d-97e3-14d12155ddfe.jpg",
        title:"Farms"

    },
    {
        img:"https://a0.muscache.com/pictures/6ad4bd95-f086-437d-97e3-14d12155ddfe.jpg",
        title:"Countryside"
    },
    {
        img:"https://a0.muscache.com/pictures/c5a4f6fc-c92c-4ae8-87dd-57f1ff1b89a6.jpg",
        title:"OMG!"
    },
    {
        img:"https://a0.muscache.com/pictures/3fb523a0-b622-4368-8142-b5e03df7549b.jpg",
        title:"Amazing pools"
    },
    {
        img:"https://a0.muscache.com/pictures/eb7ba4c0-ea38-4cbb-9db6-bdcc8baad585.jpg",
        title:"Private rooms"
    },
    {
        img:"https://a0.muscache.com/pictures/bcd1adc0-5cee-4d7a-85ec-f6730b0f8d0c.jpg",
        title:"Beachfront"
    },
    {
        img:"https://a0.muscache.com/pictures/c8e2ed05-c666-47b6-99fc-4cb6edcde6b4.jpg",
        title:"Luxe"
    },

    {
        img:"https://a0.muscache.com/pictures/732edad8-3ae0-49a8-a451-29a8010dcc0c.jpg",
        title:"Cabins"
    },
    {
        img:"https://a0.muscache.com/pictures/35919456-df89-4024-ad50-5fcb7a472df9.jpg",
        title:"Tiny homes"
    },

    {
        img:"https://a0.muscache.com/pictures/3726d94b-534a-42b8-bca0-a0304d912260.jpg",
        title:"Trending"
    },
    {
        img:"https://a0.muscache.com/pictures/4d4a4eba-c7e4-43eb-9ce2-95e1d200d10e.jpg",
        title:"Treehouses"
    },
    {
        img:"https://a0.muscache.com/pictures/c0a24c04-ce1f-490c-833f-987613930eca.jpg",
        title:"National parks"
    },
    {
        img:"https://a0.muscache.com/pictures/1b6a8b70-a3b6-48b5-88e1-2243d9172c06.jpg",
        title:"Castles"
    },
    {
        img:"https://a0.muscache.com/pictures/33dd714a-7b4a-4654-aaf0-f58ea887a688.jpg",
        title:"Historical homes"
    },
    {
        img:"https://a0.muscache.com/pictures/8e507f16-4943-4be9-b707-59bd38d56309.jpg",
        title:"Islands"
    },
    {
        img:"https://a0.muscache.com/pictures/677a041d-7264-4c45-bb72-52bff21eb6e8.jpg",
        title:"Lakefront"
    },
    {
        img:"https://a0.muscache.com/pictures/ee9e2a40-ffac-4db9-9080-b351efc3cfc4.jpg",
        title:"Tropical"
    },
    {
        img:"https://a0.muscache.com/pictures/248f85bf-e35e-4dc3-a9a1-e1dbff9a3db4.jpg",
        title:"Castles"
    },
    {
        img:"https://a0.muscache.com/pictures/1b6a8b70-a3b6-48b5-88e1-2243d9172c06.jpg",
        title:"Top of the world"
    },
    {
        img:"https://a0.muscache.com/pictures/1d477273-96d6-4819-9bda-9085f809dad3.jpg",
        title:"A-frames"
    },
    {
        img:"https://a0.muscache.com/pictures/60ff02ae-d4a2-4d18-a120-0dd274a95925.jpg",
        title:"Vineyards"
    }
]
export default FilterIcon